export const checkHasSelectedSpecialSeat = (selectedSeats) => {
  // 対象 > 5:車椅子, 6:介護
  const targetSeatAttribute = ["5", "6"];
  return selectedSeats.some(seat => targetSeatAttribute.includes(seat.seat.seat_attribute));
}